import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntPesticides } from "../../../../models/chemicalization/pesticides";
import {
  useAddPesticidesMutation,
  useDeletePesticidesMutation,
  useEditPesticidesMutation
} from "../../../../redux/api/chemicalization/pesticides";


const usePesticides = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [ addPesticides] = useAddPesticidesMutation();
  const [ deletePesticides ] = useDeletePesticidesMutation();
  const [ editPesticides ] = useEditPesticidesMutation();

  async function onAddPesticides(newPesticides: EntPesticides): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addPesticides(newPesticides).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeletePesticides(pesticides: EntPesticides) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deletePesticides(pesticides.id as number).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }

  async function onEditPesticides(editedPesticides: EntPesticides): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editPesticides(editedPesticides).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }

  return { onAddPesticides, onDeletePesticides, onEditPesticides };

}
export { usePesticides };

